export function eur(cents: number | null): string {
  if (cents === null || !Number.isSafeInteger(cents)) return '—';
  const sign = cents < 0 ? '-' : '';
  const minor = BigInt(cents < 0 ? -cents : cents);
  return `€${sign}${(minor / 100n).toLocaleString('en-IE')}.${String(minor % 100n).padStart(2, '0')}`;
}
